export { default as TestInformationPage } from "./testInformation";
